const DEFAULT_CONFIG = {
  dcp: { short: 'DCP', full: 'Digital Career Passport' },
  bio: { label: 'Bio', maxLength: 500 },
  preferredName: { show: true }, // Preferred Name field shown for all clubs
  communityWork: { label: 'Community Work' },
  transferableSkills: { label: 'Transferable Skills' },
};

const CLUB_OVERRIDES = {
  'a5b4511b-0f6e-a920-d899-26cdcda18fa8': { // More Than Words
    dcp: { short: 'DPP', full: 'Digital Progress Passport' },
    bio: { label: 'All About Me', maxLength: 2500 },
    // preferredName uses default (show: true) for all clubs
    communityWork: { label: 'Community Events' },
    transferableSkills: { label: 'MTW Outcomes' },
  },
  // To add another org: paste a new block here with the club ID and any overrides.
  // Only include the keys you want to change — defaults apply for everything else.
};

export const getClubConfig = (clubId) => ({
  ...DEFAULT_CONFIG,
  ...(CLUB_OVERRIDES[clubId] ?? {}),
});
